import { IGoal } from 'motw_core/Entity/IGoal';
import { ILogState } from 'source/app/presentation/MainPanel/Log/ILogState';
import { State } from 'source/app/services/UI/State/State';
import { ESharedComponent } from 'source/app/services/UI/State/ESharedComponent';

export function PopulateLogStateFromGoal(goal: IGoal) {
	const log = State.ReadClass<ILogState>(ESharedComponent.Log);
	
	if (log) {
		log.setState({
			inpVerb: goal.verb!,
			LogInpEntryText: `${goal.name!} ${goal.is1time ? 1 : ``}`,
			clickedGoalId: goal.id
		});
	}
}
